import styled from 'styled-components'

import Button from 'components/Button'
import { style } from 'theme'

export const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
`

export const AlternativeAcornsLogo = styled.img`
  display: flex;
  align-self: flex-start;
  margin: auto;
  margin-top: 30px;
  object-fit: cover;
  margin-bottom: 30px;
`

export const LeftAlignAcornImage = styled.img`
  display: flex;
  align-self: flex-start;
  margin-top: 30px;
  object-fit: cover;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
  }
`

export const StyledLabel = styled.div`
  font-size: 12px;
  color: ${style(theme => theme.colors.slate)};
  margin-top: 2px;
`
export const StyledHeroHeader = styled.div<{ isEmailRowDisplayed: boolean; isMilitary: boolean }>`
  margin: 0px auto 6px;
  margin-bottom: 40px;
  max-width: 380px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
    font-size: ${props => (props.isEmailRowDisplayed ? '30px' : '22px')};
    line-height ${props => (props.isEmailRowDisplayed ? '38px' : '30px')};
    text-align: ${props => (props.isEmailRowDisplayed && !props.isMilitary ? 'left' : 'center')};
  }
  @media (min-width: ${style(theme => theme.breakpoints.sm)}px) {
    font-size: 22px;
    line-height: 30px;
    text-align: center;
  }
`
export const StyledSubText = styled.div`
  font-size: 16px;
  line-height 24px;
  margin: 10px auto;
  max-width: 315px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    text-align: left;
  }
  @media (min-width:${style(theme => theme.breakpoints.sm)}px) {
    text-align: center;
  }
`
export const StyledHeroSubtext = styled.div`
  font-size: 14px;
  display: inline;
  p {
    display: inline;
    margin: 0;
    line-height: 22px;
  }
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: flex;
    align-items: center;
    max-width: 340px;
  }
`

export const AlternativeStyledHeroSubtext = styled.div`
  font-size: 14px;
  font-style: italic;
  display: inline;
  color: ${style(theme => theme.colors.stone)};
  p {
    display: inline;
    margin: 0;
  }
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 340px;
    display: flex;
    align-items: center;
    max-width: 340px;
  }
`

export const StyledHeroDescription = styled.div`
  width: 55%;
  margin: 0 auto 40px;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
    margin-bottom: 30px;
  }
`

export const StyledHeroCaption = styled.div`
  width: 50%;
  margin: 20px auto 80px;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    width: 100%;
    text-align: left;
    margin: 20px 0;
  }
`

export const ButtonContainer = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: ${style(theme => theme.colors.white)};
    bottom: 0;
    left: 0;
    padding: 10px 0 0 0;
    position: fixed;
    width: 100%;
    text-align: center;
  }
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 15px;
    height: 44px;
    margin: 8px 20px 20px 20px;
    position: sticky;
    width: calc(100vw - 40px);
  }
`

export const LinkInCTAContainer = styled.div<{ show: boolean }>`
  display: none;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    ${props => props.show && 'display: block;'}
    padding: 0 0 10px;
  }
`
